"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const prism_1 = __importDefault(require("react-syntax-highlighter/prism"));
const React = __importStar(require("react"));
const prism_2 = require("react-syntax-highlighter/styles/prism");
const Highlighter = (props) => {
    let language = props.language;
    if (language === "ipython") {
        language = "python";
    }
    else if (language === "text/x-scala") {
        // Adjust for the scala codemirror type
        language = "scala";
    }
    else if (language.startsWith("text/x-")) {
        // Strip off the language from the mimetype
        language = language.slice("text/x-".length);
    }
    return (React.createElement(prism_1.default, { style: props.theme === "light" ? prism_2.vs : prism_2.xonokai, language: language, className: props.className, customStyle: {
            padding: "10px 0px 10px 10px",
            margin: "0px",
            backgroundColor: "var(--cm-background, #fafafa)",
            border: "none"
        } }, props.children));
};
Highlighter.defaultProps = {
    theme: "light",
    language: "text",
    children: "",
    className: "input"
};
exports.default = Highlighter;
